import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import {
  IApiServiceConfig,
  API_SERVICE_CONFIG,
} from '../base/configuration/api-service-config';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiPushSubscriptionsAdapterService {
  private readonly endpointUrl = this.config.url + 'push-subscriptions';

  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  create(sub: PushSubscription): Observable<void> {
    return this.http.post<void>(this.endpointUrl, sub.toJSON());
  }
}
